import { render, staticRenderFns } from "./ContractReleaseCode.vue?vue&type=template&id=22e55b0c&scoped=true&"
import script from "./ContractReleaseCode.vue?vue&type=script&lang=js&"
export * from "./ContractReleaseCode.vue?vue&type=script&lang=js&"
import style0 from "./ContractReleaseCode.vue?vue&type=style&index=0&id=22e55b0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e55b0c",
  null
  
)

export default component.exports